/**
 * Admin-configured floating bubble markup (`widget_bubble_icon`).
 * Rejects JSON/DB artefacts and non-markup strings so we never inject
 * the literal text "null" into the shadow DOM.
 */
export function sanitizeWidgetBubbleIconSvg(raw) {
  if (raw == null) return ''
  const s = String(raw).trim()
  if (!s || /^null$/i.test(s) || /^undefined$/i.test(s)) return ''
  if (!s.includes('<')) return ''
  return s
}
